module.exports = __webpack_public_path__ + "static/media/spacely.8f137a34.png";